module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      key: order.id
    }, [_c('order', {
      attrs: {
        "order-id": order.id
      }
    })], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1526cc1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/orders/AllOrders.vue
// module id = 502
// module chunks = 0